 import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const MuthootFinanceBikeLoanEmi      = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            "question": "What is the purpose of the Muthoot Finance Bike Loan EMI Calculator?",
            "answer": "The calculator helps estimate your monthly repayment amount (EMI) based on the loan amount, interest rate, and tenure, enabling better financial planning before applying."
          },
          {
            "question": "Is the EMI calculated by the calculator fixed for the entire loan tenure?",
            "answer": "Yes, if you choose a fixed interest rate loan, your EMI remains the same throughout the tenure. Floating rates can cause EMIs to fluctuate."
          },
          {
            "question": "Can I use the calculator multiple times for different loan amounts and tenures?",
            "answer": "Absolutely! You can input different values as many times as needed to compare repayment options and select the most suitable plan."
          },
          {
            "question": "Does the calculator consider processing fees or other charges?",
            "answer": "No, the EMI calculator focuses on principal and interest payments. Processing fees, GST, and other charges are separate and not included in the EMI."
          },
          {
            "question": "How accurate is the Muthoot Finance Bike Loan EMI Calculator?",
            "answer": "The calculator uses the standard EMI formula based on fixed interest rates and tenure, giving a very accurate estimate of your monthly payments. However, actual figures may vary slightly due to additional charges or changes in rates."
          },
          {
            "question": "Can I calculate EMIs for prepayment or foreclosure scenarios?",
            "answer": "The calculator primarily estimates EMIs for the initial loan schedule. For prepayment or foreclosure calculations, consult Muthoot Finance or use specific prepayment calculators."
          },
          {
            "question": "What happens if my interest rate changes during the loan tenure?",
            "answer": "If you have a floating interest rate loan, the EMI amount may increase or decrease based on market conditions and the lender’s policy."
          },
          {
            "question": "Will using the EMI calculator affect my credit score?",
            "answer": "No, using the calculator is purely informational and does not impact your credit score."
          },
          {
            "question": "What loan tenure options does Muthoot Finance typically offer for bike loans?",
            "answer": "Muthoot Finance usually offers tenures ranging from 12 months up to 60 months, depending on your eligibility and loan amount."
          },
          {
            "question": "How can a better credit score influence my bike loan EMI?",
            "answer": "A higher credit score may qualify you for lower interest rates, reducing your EMI and overall loan cost."
          },
          {
            "question": "Does the calculator consider down payment or advance payments?",
            "answer": "No, it assumes the full loan amount as principal. Down payments should be subtracted from the bike price before calculating the loan amount."
          },
          {
            "question": "Can the EMI calculator be used for both new and used bike loans?",
            "answer": "Yes, the calculator works for any bike loan as long as you input the correct loan amount, rate, and tenure."
          },
          {
            "question": "Are there penalties if I miss an EMI payment?",
            "answer": "Yes, missing EMIs may attract late fees and can negatively impact your credit score. It's crucial to plan repayments carefully."
          },
          {
            "question": "How can I reduce my EMI amount?",
            "answer": "Increasing the loan tenure or improving your credit score to avail a lower interest rate can help reduce your EMI."
          },
          {
            "question": "Is it necessary to visit a Muthoot Finance branch to use the EMI calculator?",
            "answer": "No, the EMI calculator is an online tool available on TheFinMaster and other platforms, accessible anytime from your phone or computer."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
         <title>Muthoot Finance Bike Loan EMI Calculator – Calculate EMIs Instantly</title>
        <meta  name='description' content='Plan your Muthoot Finance bike loan repayments. Use this EMI calculator to understand your monthly financial commitments.'/>
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/muthoot-finance-bank-bike-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">  Muthoot Finance Bike Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
        <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
            <h1 className="text-2xl font-bold mb-4">  Muthoot Finance Bike Loan EMI Calculator</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Calculate Your Bike Loan EMI with TheFinMaster’s Muthoot Finance Bike Loan EMI Calculator
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Buying a bike is a dream for many, and managing its finances smoothly is key to making that dream a reality. At TheFinMaster, we introduce you to the Muthoot Finance Bike Loan EMI Calculator, a smart, user-friendly online tool that empowers you to plan your monthly payments precisely before you commit to a loan. This calculator offers you transparency and control over your loan repayment schedule, helping you make well-informed financial decisions and stay stress-free throughout your loan tenure.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is an EMI and Why Does It Matter for Your Bike Loan?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI stands for Equated Monthly Installment — the fixed amount you pay every month toward repaying your bike loan. Each EMI includes two parts: the principal repayment (the actual loan amount) and the interest charged by the lender on the outstanding loan balance. Paying a fixed EMI every month ensures that your bike loan is repaid over the agreed tenure without any surprises or lump-sum payments.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For borrowers, understanding the EMI helps in better budgeting, ensuring the loan repayment fits comfortably within their monthly income. The Muthoot Finance Bike Loan EMI Calculator breaks down this repayment into simple, digestible numbers, guiding you every step of the way.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Introducing TheFinMaster’s Muthoot Finance Bike Loan EMI Calculator
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Muthoot Finance Bike Loan EMI Calculator is designed specifically to calculate your monthly installments for bike loans provided by Muthoot Finance. With this calculator, you can quickly input your loan amount, tenure, and interest rate to get an accurate estimate of your monthly EMI and total interest payable.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This tool is specially tailored to Muthoot Finance’s lending terms and policies, ensuring that you receive realistic and applicable calculations based on their interest rates, tenure options, and fees.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use the Muthoot Finance Bike Loan EMI Calculator on TheFinMaster?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Precise Financial Forecasting:</strong> Accurately plan your monthly budget by knowing exactly how much EMI you need to pay, reducing financial surprises.</li>
                <li><strong>Time-Saving:</strong> No more manual math or complex spreadsheets. Just input your numbers and get instant results.</li>
                <li><strong>Flexible Inputs:</strong> Adjust loan amount, interest rate, and tenure to see different repayment scenarios and choose the best fit.</li>
                <li><strong>Transparent Cost Overview:</strong> Understand how much interest you will pay in total and how different factors affect your monthly payment.</li>
                <li><strong>No Hidden Charges:</strong> This free tool shows you the gross EMI amount without hidden or additional fees.</li>
                <li><strong>Convenient and Accessible:</strong> Available online anytime, making it easier to plan your finances at your convenience.</li>
              </ul>
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the Muthoot Finance Bike Loan EMI Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The calculator uses a standard formula to break down your total loan amount and interest over the loan period into equal monthly payments. It assumes a fixed interest rate for the entire tenure and monthly repayments on a set date.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The EMI Calculation Formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P x R x (1+R)^N] / [(1+R)^N – 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P = Loan Amount</li>
              <li>R = Monthly Interest Rate</li>
              <li>N = Loan Tenure in Months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong><br />
              Imagine you take a bike loan of ₹1,50,000 from Muthoot Finance at an interest rate of 11% per annum for a tenure of 36 months.<br />
              Loan Amount (P) = ₹1,50,000<br />
              Annual Interest Rate = 11%<br />
              Monthly Interest Rate (r) = 11/(12*100) = 0.00916<br />
              Tenure (n) = 36 months<br />
              The calculator applies this formula to give you your exact EMI amount, which helps you budget efficiently.
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Understanding Your Amortisation Schedule
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The amortisation schedule is a detailed table that breaks down each monthly EMI into the principal and interest components. Early in the loan tenure, a larger portion of your EMI goes towards interest, while over time, the principal repayment portion increases. By the end of your tenure, the entire loan principal is repaid.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Knowing your amortisation schedule helps you track your outstanding loan balance, plan prepayments if possible, and understand how your money is distributed during the loan period.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Sample 12-Month Amortisation Schedule for Muthoot Finance Bike Loan</strong>
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">EMI Amount (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Remaining Principal (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">4,987</td>
                    <td className="border px-4 py-2">3,637</td>
                    <td className="border px-4 py-2">1,350</td>
                    <td className="border px-4 py-2">1,46,363</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">4,987</td>
                    <td className="border px-4 py-2">3,671</td>
                    <td className="border px-4 py-2">1,316</td>
                    <td className="border px-4 py-2">1,42,692</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">4,987</td>
                    <td className="border px-4 py-2">3,706</td>
                    <td className="border px-4 py-2">1,281</td>
                    <td className="border px-4 py-2">1,38,986</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">4,987</td>
                    <td className="border px-4 py-2">3,741</td>
                    <td className="border px-4 py-2">1,246</td>
                    <td className="border px-4 py-2">1,35,245</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">4,987</td>
                    <td className="border px-4 py-2">3,776</td>
                    <td className="border px-4 py-2">1,211</td>
                    <td className="border px-4 py-2">1,31,469</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">4,987</td>
                    <td className="border px-4 py-2">3,812</td>
                    <td className="border px-4 py-2">1,175</td>
                    <td className="border px-4 py-2">1,27,657</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">4,987</td>
                    <td className="border px-4 py-2">3,848</td>
                    <td className="border px-4 py-2">1,139</td>
                    <td className="border px-4 py-2">1,23,809</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">4,987</td>
                    <td className="border px-4 py-2">3,884</td>
                    <td className="border px-4 py-2">1,103</td>
                    <td className="border px-4 py-2">1,19,925</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">4,987</td>
                    <td className="border px-4 py-2">3,920</td>
                    <td className="border px-4 py-2">1,067</td>
                    <td className="border px-4 py-2">1,16,005</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">4,987</td>
                    <td className="border px-4 py-2">3,957</td>
                    <td className="border px-4 py-2">1,030</td>
                    <td className="border px-4 py-2">1,12,048</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">4,987</td>
                    <td className="border px-4 py-2">3,994</td>
                    <td className="border px-4 py-2">993</td>
                    <td className="border px-4 py-2">1,08,054</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">4,987</td>
                    <td className="border px-4 py-2">4,031</td>
                    <td className="border px-4 py-2">956</td>
                    <td className="border px-4 py-2">1,04,023</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI Amount (₹)</th>
          <th className="border px-4 py-2 text-left">Principal    (₹)</th>
          <th className="border px-4 py-2 text-left">Interest (₹)</th>
          <th className="border px-4 py-2 text-left">Remaining Principal (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
          ["1", "4,987", "3,637", "1,350", "1,46,363"],
          ["2", "4,987", "3,671", "1,316", "1,42,692"],
          ["3", "4,987", "3,706", "1,281", "1,38,986"],
          ["4", "4,987", "3,741", "1,246", "1,35,245"],
          ["5", "4,987", "3,776", "1,211", "1,31,469"],
          ["6", "4,987", "3,812", "1,175", "1,27,657"],
          ["7", "4,987", "3,848", "1,139", "1,23,809"],
          ["8", "4,987", "3,884", "1,103", "1,19,925"],
          ["9", "4,987", "3,920", "1,067", "1,16,005"],
          ["10", "4,987", "3,957", "1,030", "1,12,048"],
          ["11", "4,987", "3,994", "993", "1,08,054"],
          ["12", "4,987", "4,031", "956", "1,04,023"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
           ["1", "4,987", "3,637", "1,350", "1,46,363"],
           ["2", "4,987", "3,671", "1,316", "1,42,692"],
           ["3", "4,987", "3,706", "1,281", "1,38,986"],
           ["4", "4,987", "3,741", "1,246", "1,35,245"],
           ["5", "4,987", "3,776", "1,211", "1,31,469"],
           ["6", "4,987", "3,812", "1,175", "1,27,657"],
           ["7", "4,987", "3,848", "1,139", "1,23,809"],
           ["8", "4,987", "3,884", "1,103", "1,19,925"],
           ["9", "4,987", "3,920", "1,067", "1,16,005"],
           ["10", "4,987", "3,957", "1,030", "1,12,048"],
           ["11", "4,987", "3,994", "993", "1,08,054"],
           ["12", "4,987", "4,031", "956", "1,04,023"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI Amount (₹):</span> {emi}</div>
        <div><span className="font-semibold"> Principal   (₹):</span> {interest}</div>
        <div><span className="font-semibold">Interest   (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Remaining Principal(₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Note: Figures are illustrative and rounded.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Key Factors Affecting Your Muthoot Finance Bike Loan EMI
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Loan Amount:</strong> The EMI increases with a higher loan amount, so borrowing within your repayment ability is crucial.</li>
                <li><strong>Interest Rate:</strong> Even small fluctuations in the interest rate significantly affect your EMI and total repayment. Muthoot Finance offers competitive rates depending on your profile.</li>
                <li><strong>Tenure:</strong> Longer loan tenures reduce your EMI but increase total interest paid; shorter tenures have the opposite effect.</li>
                <li><strong>Processing Fees:</strong> One-time fees may add to your upfront cost but usually don't affect monthly EMI.</li>
                <li><strong>Prepayment Options:</strong> Partial prepayments or full foreclosure can reduce your loan burden but might include penalties.</li>
                <li><strong>Credit Score:</strong> A strong credit history can qualify you for lower interest rates, thus lowering your EMI.</li>
                <li><strong>Income & Employment:</strong> Your repayment capacity influences sanctioned loan amount and applicable rates, indirectly impacting your EMI.</li>
              </ul>
            </p>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                         {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
        
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default MuthootFinanceBikeLoanEmi  ;
